import Page from './table/table.vue';

export default Page;
